import axios from 'axios'
import endpoints from '../../config/endpoints.json'
import { ISkill } from '../../domain/entities/Skill'

export function getAllSkills(): Promise<{ items: ISkill[] }> {
  return axios.get(endpoints.skill.all)
}
